// extracted by mini-css-extract-plugin
module.exports = {"order_card":"OrderItem_order_card__2FZms","options":"OrderItem_options__9Dcgi","reports":"OrderItem_reports__24IiM"};